import {
    SET_CAMPAIGN_LIST_DATA
} from '../../actions/campaign';

const initialState = {
    dataList: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_CAMPAIGN_LIST_DATA:
            return { ...state, dataList: action.payload.items };
        default:
            return state;
    }
}